import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { formatCount } from "./utils";
import { createDisplayNameForAvaPictureElement } from "../../utils/getDisplayName";
import { createTestIdForAvaPictureElement } from "../../utils/getTestId";

import type { PropsWithCustomVarsStyles } from "../../../../types/react";
import type { AvaPictureShapes, AvaPictureSizes } from "../../types";

import classes from "./AvaPictureCount.styl";

type AvaPictureCountPrivateProps = PropsWithCustomVarsStyles<{
    /**
     * Отвечает за значение счётчика.
     * Значение форматируется согласно следующим правилам:
     * - Максимальное количество символов: 2
     * - Слева от значения отображается +, если значение не максимальное.
     * - При достижении максимального + отображается справа от значения
     * - Если числовое значение превышает +9, то компонент отображает 9+
     */
    countValue: number;
    size: AvaPictureSizes;
    shape: AvaPictureShapes;
}>;

export type AvaPictureCountProps = Omit<
    AvaPictureCountPrivateProps,
    "size" | "shape"
>;

export const AVA_PICTURE_COUNT_TEST_ID =
    createTestIdForAvaPictureElement("count");

export const AvaPictureCount: FC<AvaPictureCountProps> = (props) => {
    const { countValue, size, shape, customVarsStyles } =
        props as AvaPictureCountPrivateProps;

    const classNames = cn(
        classes["count"],
        classes[`__size-${size}`],
        classes[`__shape-${shape}`],
        customVarsStyles,
    );

    return (
        <div data-tsid={AVA_PICTURE_COUNT_TEST_ID} className={classNames}>
            {formatCount(countValue)}
        </div>
    );
};

AvaPictureCount.displayName = createDisplayNameForAvaPictureElement("Count");

export default AvaPictureCount;
